import * as CANNON from 'cannon-es';
import { Vec3 } from 'cannon-es';
import { BoxBufferGeometry, Float32BufferAttribute, Mesh, MeshStandardMaterial, } from 'three';
import { createBoundry } from '../utils/utils';
class PlaneFactory {
    static createPlane(dimensions, phyicsMaterial, position, configObj, scoreKeeper) {
        const { width, height, depth } = dimensions;
        const geometry = new BoxBufferGeometry(width, height, depth, 64, 64);
        const material = new MeshStandardMaterial(configObj
            ? configObj
            : { color: 'rgb(0,12,64)', transparent: true, opacity: 0.4 });
        const mesh = new Mesh(geometry, material);
        mesh.receiveShadow = true;
        mesh.rotation.x = -Math.PI * 0.5;
        mesh.geometry.setAttribute('uv2', new Float32BufferAttribute(mesh.geometry.attributes.uv.array, 2));
        if (position) {
            const { x, y, z } = position;
            mesh.position.set(x, y, z);
        }
        if (scoreKeeper) {
            this.addPointsToPlane(dimensions, position, scoreKeeper);
        }
        const shape = new CANNON.Box(new Vec3(width / 2, height / 2, depth / 2));
        const body = createBoundry(-1, 0, 0, 0, 0, 0, Math.PI * 0.5, shape, phyicsMaterial);
        body.position.copy(mesh.position);
        return { mesh, body };
    }
    // Used for adding points to the plane
    static addPointsToPlane(dimension, position, scoreKeeper) {
        const { width, height } = dimension;
        const { x, y, z } = position;
        const spaceBetweenPoints = 15;
        const offset = 5;
        // Since position is based on middle of plane, we need to add half plane at start of iteration
        let appendage = height > width ? height / 2 : width / 2;
        // Create coins at earliest 5px near the closest edge of plane
        if (height > width) {
            appendage = height / 2;
            for (let index = offset; index < height - offset; index += spaceBetweenPoints) {
                scoreKeeper.createCoin(x, y + offset, z - appendage + index);
            }
        }
        else {
            for (let index = offset; index < width - offset; index += spaceBetweenPoints) {
                scoreKeeper.createCoin(x - appendage + index, y + offset, z);
            }
        }
    }
    static slopePlane(plane, rotationX, rotationY, rotationZ) {
        plane.mesh.rotation.x = -rotationX;
        plane.mesh.rotation.y = rotationY;
        plane.mesh.rotation.z = rotationZ;
        const angleX = rotationX;
        const angleY = rotationY;
        const angleZ = rotationZ;
        const quatX = new CANNON.Quaternion();
        const quatY = new CANNON.Quaternion();
        const quatZ = new CANNON.Quaternion();
        quatX.setFromAxisAngle(new CANNON.Vec3(-1, 0, 0), angleX);
        quatY.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), angleY);
        quatZ.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), angleZ);
        const quaternion = quatX.mult(quatY).mult(quatZ);
        plane.body.quaternion = quaternion;
        plane.body.position.copy(plane.mesh.position);
    }
    static slopePlaneUpRight(plane) {
        this.slopePlane(plane, -Math.PI / 2, Math.PI / 6, Math.PI / 2);
    }
    static slopePlaneUpLeft(plane) {
        this.slopePlane(plane, Math.PI / 2, Math.PI / 6, Math.PI / 2);
    }
    static slopePlaneUpBack(plane) {
        this.slopePlane(plane, -Math.PI / 3, Math.PI, Math.PI);
    }
    static slopePlaneUp(plane) {
        this.slopePlane(plane, Math.PI / 3, Math.PI, Math.PI);
    }
}
export default PlaneFactory;
